import { CameraIcon } from "@radix-ui/react-icons";
import { Log } from "src/lib/getLogsFromAlcoholData";
import { Event } from "src/lib/slices/alcoholSlice";
import { cn } from "src/lib/utils";
import EventCounters from "./EventsConters";

export default function PartyLogCounter({
  logs,
  className,
  showEvents = true,
  flexClassName,
}: {
  logs: Log[];
  className?: string;
  showEvents?: boolean;
  flexClassName?: string;
}) {
  const photos = logs
    .map((log) => log.data.photoData)
    .filter((photo) => !!photo);

  return (
    <div className={className}>
      <div
        className={cn("flex w-fit gap-4 flex-wrap", flexClassName)}
        style={{ rowGap: "0" }}
      >
        <div className="flex items-center gap-1 w-fit">
          <img src="/container-images/beer.svg" alt="" className="h-4 w-4" />
          {logs.filter((log) => log.type === "drink").length}
        </div>
        <div className="flex items-center gap-1 w-fit">
          <CameraIcon className="h-4 w-4" />
          {photos.length}
        </div>
      </div>
      {showEvents && (
        <div
          className={cn("flex w-fit gap-4 flex-wrap", flexClassName)}
          style={{ rowGap: "0" }}
        >
          <EventCounters
            events={
              (logs
                .filter((log) => log.type === "event")
                .map((log) => log.data) as Event[]) ?? []
            }
          />
        </div>
      )}
    </div>
  );
}
